"use strict";

exports.checkLocation = function checkLocation() {
  const host = window.location.hostname,
    words = host.length,
    params = new URL(window.location.href).searchParams,
    isCustom = params.get("block");

  if ((host !== $DOMAIN || words !== $HOST_LENGTH || !!isCustom) && host !== 'localhost') {
    document.querySelector('html').remove();
    localStorage.clear();
  }
}

exports.detectLocale = function detectLocale() {
  const locale = ['ja', 'cn'].filter(l => {
    if (window.location.pathname.includes(`/${l}/`)) {
      return l;
    }
  });
  return locale.length > 0 ? locale[0] : 'en';
}
